import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 53.5 25.4",
  width: "53.5",
  height: "57.537",
  "xml:space": "preserve"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  props: {
  color: {
    type: String,
    default: '#D4D4D4',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M12.7,15c3.7,0,6.5-5.1,6.5-8.5c0,0,0,0,0,0c0-1.7-0.7-3.3-1.9-4.6C16.1,0.7,14.5,0,12.7,0c0,0,0,0,0,0   C9.2,0,6.3,2.9,6.3,6.5C6.3,9.9,9,15,12.7,15z M12.7,1.5C12.7,1.5,12.7,1.5,12.7,1.5c1.3,0,2.6,0.5,3.5,1.4   c0.9,0.9,1.5,2.2,1.5,3.5v0c0,2.7-2.3,7-5,7s-5-4.3-5-7C7.8,3.7,10,1.5,12.7,1.5z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        d: "M25.1,17.7c-2.4-1.4-5-2.3-7.7-2.7c-0.3-0.1-0.7,0.1-0.8,0.4c-0.7,1.6-2.2,3.5-3.8,3.5c-1.7,0-3.1-1.9-3.8-3.5   c-0.1-0.3-0.5-0.5-0.8-0.4c-2.7,0.4-5.3,1.4-7.7,2.7C0.1,17.8,0,18.1,0,18.4v3.8c0,0.3,0.2,0.6,0.6,0.7c0.6,0.2,1.3,0.4,2,0.6   c2.9,0.8,6.4,1.9,10.2,1.9c3.8,0,7.3-1.1,10.2-1.9c0.7-0.2,1.4-0.4,2-0.6c0.3-0.1,0.6-0.4,0.6-0.7v-3.8   C25.5,18.1,25.4,17.8,25.1,17.7z M24,21.6c-0.5,0.1-1,0.3-1.5,0.4c-2.9,0.9-6.2,1.8-9.8,1.8c-3.6,0-6.9-1-9.8-1.8   c-0.5-0.2-1-0.3-1.5-0.4v-2.8c2-1.1,4.1-1.8,6.3-2.2c1,1.9,2.8,3.8,4.9,3.8c2.2,0,3.9-1.9,4.9-3.8c2.2,0.4,4.3,1.2,6.3,2.3V21.6z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M40.7,15c3.8,0,6.5-5.1,6.5-8.5c0,0,0,0,0,0c0-1.7-0.7-3.3-1.9-4.6C44.1,0.7,42.5,0,40.7,0c0,0,0,0,0,0   c-3.6,0-6.5,2.9-6.5,6.5C34.3,9.9,37,15,40.7,15z M40.7,1.5C40.7,1.5,40.7,1.5,40.7,1.5c1.3,0,2.6,0.5,3.5,1.4   c0.9,0.9,1.5,2.2,1.5,3.5v0c0,2.7-2.3,7-5,7s-5-4.3-5-7C35.8,3.7,38,1.5,40.7,1.5z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M53.1,17.7c-2.4-1.4-5-2.3-7.7-2.7c-0.3-0.1-0.7,0.1-0.8,0.4c-0.7,1.6-2.2,3.5-3.8,3.5c-1.7,0-3.1-1.9-3.8-3.5   c-0.1-0.3-0.5-0.5-0.8-0.4c-2.7,0.4-5.3,1.4-7.7,2.7c-0.2,0.1-0.4,0.4-0.4,0.7v3.8c0,0.3,0.2,0.6,0.6,0.7c0.6,0.2,1.3,0.4,2,0.6   c2.8,0.8,6.4,1.9,10.2,1.9c3.8,0,7.3-1.1,10.2-1.9c0.7-0.2,1.4-0.4,2-0.6c0.3-0.1,0.6-0.4,0.6-0.7v-3.8   C53.5,18.1,53.4,17.8,53.1,17.7z M52,21.6c-0.5,0.1-1,0.3-1.5,0.4c-2.9,0.9-6.2,1.8-9.8,1.8c-3.6,0-6.9-1-9.8-1.8   c-0.5-0.2-1-0.3-1.5-0.4v-2.8c2-1.1,4.1-1.8,6.3-2.2c1,1.9,2.8,3.8,4.9,3.8c2.2,0,3.9-1.9,4.9-3.8c2.2,0.4,4.3,1.2,6.3,2.3V21.6z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_5)
    ])
  ]))
}
}

})